// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponGetEnrollmentDetailsDefaultResponse {
    static getAttributeTypeMap() {
        return CouponGetEnrollmentDetailsDefaultResponse.attributeTypeMap;
    }
}
CouponGetEnrollmentDetailsDefaultResponse.discriminator = undefined;
CouponGetEnrollmentDetailsDefaultResponse.additionalProperties = false;
CouponGetEnrollmentDetailsDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "CouponGetEnrollmentDetailsDefaultResponseData"
    },
];
//# sourceMappingURL=couponGetEnrollmentDetailsDefaultResponse.js.map